"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _LoggingEnabled_1 = require("./_LoggingEnabled");
exports._BucketLoggingStatus = {
    type: "structure",
    required: [],
    members: {
        LoggingEnabled: {
            shape: _LoggingEnabled_1._LoggingEnabled
        }
    }
};
//# sourceMappingURL=_BucketLoggingStatus.js.map